<template>
  <div class="col-11 pl-0 ml-0">
    <v-row>
      <v-col class="pb-0">
        <p class="title pl-0 ml-0 mb-0 mt-5">결제 하기</p>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="pb-0">
        <v-text-field
          v-model="ordersPayload.mall_name"
          label="쇼핑몰명"
          single-line
          outlined
          dense
          autocomplete="off"
        ></v-text-field>
      </v-col>
      <v-col class="pb-0">
        <v-text-field
          v-model="ordersPayload.mall_manager"
          label="담당자명"
          single-line
          outlined
          dense
          autocomplete="off"
        ></v-text-field>
      </v-col>
      <v-col class="pb-0">
        <v-text-field
          v-model="ordersPayload.mall_phone"
          label="핸드폰번호"
          single-line
          outlined
          dense
          autocomplete="off"
          @keydown="M.checkNumber($event)"
          @keypress="M.replaceNumber($event, 12, false)"
          @blur="M.replaceNumber($event, 12, false)"
        ></v-text-field>
      </v-col>
      <v-col class="pb-0">
        <v-text-field
          v-model="ordersPayload.mall_email"
          label="이메일주소"
          single-line
          outlined
          dense
          autocomplete="off"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="col-6 pt-0 pb-0">
        <v-select
          v-model="ordersPayload.mall_order_type"
          :items="periodList"
          outlined
          dense
        ></v-select>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="row justify-end pt-0 pb-0 text-center">
        <v-btn large color="primary" width="200" @click.prevent="execOrder"
          >결제하기</v-btn
        >
      </v-col>
    </v-row>

    <VersionPaymentModal ref="VersionPaymentModal"></VersionPaymentModal>
  </div>
</template>

<script>
import M from "@/libs/mapping.js";
import CommonMixin from "@/mixins/CommonMixin.js";
import VersionPaymentModal from "@/components/authservice/payment/modal/VersionPaymentModal.vue";

export default {
  data() {
    return {
      M,
      periodSelected: "",
      periodList: [],
      ordersPayload: {
        mall_order_type: "",
        mall_name: "",
        mall_manager: "",
        mall_phone: "",
        mall_email: "",
      },
    };
  },
  components: {
    VersionPaymentModal,
  },
  mixins: [CommonMixin],
  methods: {
    getOrdersTypes: async function() {
      this.periodList = [
        {
          text: "사용하실 개월 수를 선택해주세요",
          value: "",
        },
      ];
      let res = await M.api(M.entry("/api/orders/types"));

      if (res) {
        res.forEach((data) => {
          if (data.app_level !== "basic") {
            let option = {
              text: data.order_name,
              value: data.order_type,
            };
            // 샵플러스 정품인증서비스 무료 15일 제외
            if (data.order_type !== 4) {
              this.periodList.push(option);
            }
          }
        });
      }
    },
    versionPaymentCilck: function() {
      this.$refs.VersionPaymentModal.versionPaymentCilck();
    },
    execOrder: async function() {
      let emailRegExp = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i;

      if (this.ordersPayload.mall_name === "") {
        this.alertShow("쇼핑몰명을 확인해주세요.");
        return false;
      }
      if (this.ordersPayload.mall_manager === "") {
        this.alertShow("담당자명을 확인해주세요.");
        return false;
      }
      if (this.ordersPayload.mall_order_type === "") {
        this.alertShow("사용하실 개월 수를 선택해주세요.");
        return false;
      }
      if (
        this.ordersPayload.mall_phone === "" ||
        this.ordersPayload.mall_phone.length < 8
      ) {
        this.alertShow("핸드폰번호를 확인해주세요.");
        return false;
      }

      if (
        this.ordersPayload.mall_email === "" ||
        this.ordersPayload.mall_email.match(emailRegExp) === null
      ) {
        this.alertShow("이메일주소를 확인해주세요.");
        return false;
      }

      let phone_number_check_result = M.isPhoneNumber(
        this.ordersPayload.mall_phone
      );
      if (
        !phone_number_check_result ||
        this.ordersPayload.mall_phone.length >= 12
      ) {
        this.alertShow("핸드폰 번호를 확인해주세요.");
        return false;
      }

      let mail_check_result = M.isMail(this.ordersPayload.mall_email);
      if (!mail_check_result) {
        this.alertShow("이메일 주소를 확인해주세요.");
        return false;
      }

      let res = await M.api(M.entry("/api/orders"), this.ordersPayload);
      if (Object.prototype.hasOwnProperty.call(res, "confirmation_url")) {
        window.location.href = res.confirmation_url;
      }
    },
  },
  created: async function() {
    try {
      let data = await M.api(M.entry("/api/orders/latest"), {});
      if (data) {
        this.ordersPayload.mall_name = data.mall_name;
        this.ordersPayload.mall_manager = data.mall_manager;
        this.ordersPayload.mall_phone = data.mall_phone;
        this.ordersPayload.mall_email = data.mall_email;
      }
    } catch {
      this.ordersPayload.mall_name = "";
      this.ordersPayload.mall_manager = "";
      this.ordersPayload.mall_phone = "";
      this.ordersPayload.mall_email = "";
    }
  },
  mounted: function() {
    this.getOrdersTypes();
  },
};
</script>
